let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("hPzOn"), load("iIfyN")]).then(() => parcelRequire('jABZI'));